export default "__VITE_ASSET__Dg7lyjYb__"